import { TableHeaderWithLayout, TableCellWithLayout } from '../../model'
import { FunctionPropertyConfiguration } from '../../../../../hooks/functionPropertyConfiguration'
import { translatePropertyLayoutString } from '../common/translatePropertyLayoutString'
import { removePrefixFromExternalId } from '../common/removePrefixFromExternalId'

export const overwriteTableHeaderWithConfig = (
  tableHeaderWithLayout: TableHeaderWithLayout,
  config: FunctionPropertyConfiguration
) => {
  if (config.name) {
    tableHeaderWithLayout.tableHeader.label = config.name
  }
  // Ignore config.parentProperty because table headers does not have parents.
  if (config.propertyLayout) {
    const tableIndex = Number(config.propertyLayout)
    if (!isNaN(tableIndex)) {
      tableHeaderWithLayout.tableIndex = tableIndex - 1
    }
  }
  // Ignore config.required because table headers are not editable.
  // Ignore config.editable because table headers are not editable.
  if (config.hidden !== undefined) {
    tableHeaderWithLayout.hidden = config.hidden
  }
}
export const overwriteTableCellWithConfig = (
  tableCellWithLayout: TableCellWithLayout,
  config: FunctionPropertyConfiguration
) => {
  if (config.name) {
    tableCellWithLayout.cell.label = config.name
  }
  if (config.parentProperty) {
    tableCellWithLayout.tableHeaderExternalId = removePrefixFromExternalId(
      config.parentProperty
    )
  }
  if (config.propertyLayout) {
    const layout = translatePropertyLayoutString(config.propertyLayout)
    tableCellWithLayout.cell.width = layout.cellWidth
    tableCellWithLayout.rowIndex = layout.rowIndex
    tableCellWithLayout.columnIndex = layout.columnIndex
  }
  if (config.required !== undefined) {
    tableCellWithLayout.cell.required = config.required
  }
  if (config.editable !== undefined) {
    tableCellWithLayout.cell.editable = config.editable
  }
  if (config.hidden !== undefined) {
    tableCellWithLayout.hidden = config.hidden
  }
}
